import "./GestionePromozioni.css";
import { Icons, iconColors } from "./icons";
import React, { useEffect, useState, useCallback } from "react";
import { db, auth } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import AIImagePopup from "./AIImagePopup";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
onSnapshot
} from "firebase/firestore";
import { 
  getStorage,
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject 
} from "firebase/storage";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./navbar-spacing.css";

const functionsUS = getFunctions(undefined, "us-central1");

const uploadAiImageViaFunction = async (base64Image, localeTag) => {
  const uploadFn = httpsCallable(functionsUS, "uploadAiImage");
  const result = await uploadFn({ base64Image, localeTag });
  return result.data?.imageUrl || "";
};

function GestionePromozioni() {
  const [promozioni, setPromozioni] = useState([]);
  const [localeTag, setLocaleTag] = useState("");
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [snackbar, setSnackbar] = useState("");
  const [aiCredits, setAiCredits] = useState(0);
const [aiEnabled, setAiEnabled] = useState(false);
const [showAIPopup, setShowAIPopup] = useState(false);
const [aiImageUploading, setAiImageUploading] = useState(false);
const [aiPreviewUrl, setAiPreviewUrl] = useState("");
const [immagineOriginale, setImmagineOriginale] = useState("");
const [menuPiatti, setMenuPiatti] = useState([]);
const [showPiattoPicker, setShowPiattoPicker] = useState(false);
  // Form per nuova promozione popup
  const [nuovoTitolo, setNuovoTitolo] = useState("");
  const [nuovoLink, setNuovoLink] = useState("");
  const [nuovaImmagine, setNuovaImmagine] = useState(null);
  const [dimensionePopup, setDimensionePopup] = useState("medio");
  const [showForm, setShowForm] = useState(false);
  const [formKey, setFormKey] = useState(0);
  
  // Modalità modifica
  const [modalitaModifica, setModalitaModifica] = useState(false);
  const [promozioneInModifica, setPromozioneInModifica] = useState(null);

  const navigate = useNavigate();

  // Dimensioni popup in base alle scelte
  const dimensioniPopup = {
    piccolo: { width: "300px", height: "250px" },
    medio: { width: "450px", height: "350px" },
    grande: { width: "600px", height: "450px" },
    fullscreen: { width: "90vw", height: "90vh" }
  };

  // Normalizza localeTag
  const normalizzaLocaleTag = (tag) => {
    return tag.toLowerCase().replace(/[^a-z0-9]/gi, "");
  };

  // Controllo autenticazione e ruolo gestore
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        navigate("/login");
        return;
      }
      
      const utenteRef = doc(db, "utenti", user.uid);
      const utenteSnap = await getDoc(utenteRef);
      
      if (!utenteSnap.exists()) {
        navigate("/login");
        return;
      }
      
      const userData = utenteSnap.data();
      
      // Solo gestore può accedere
      if (userData.ruolo !== "gestore") {
        navigate("/dashboard-gestore");
        return;
      }
      
      setLocaleTag(normalizzaLocaleTag(userData.localeTag || ""));
    });
    
        return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (!localeTag) return;

    const refCrediti = doc(db, "aiCredits", localeTag);

    const unsub = onSnapshot(refCrediti, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setAiCredits(typeof data.credits === "number" ? data.credits : 0);
        setAiEnabled(data.enabled !== false);
      } else {
        setAiCredits(0);
        setAiEnabled(false);
      }
    });

    return () => unsub();
  }, [localeTag]);

  useEffect(() => {
    const caricaPiattiMenu = async () => {
      if (!localeTag) return;

      try {
        const snapshot = await getDocs(collection(db, "menu"));

        const lista = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((p) => p.localeTag === localeTag)
          .sort((a, b) => (a.nome || "").localeCompare(b.nome || ""));

        setMenuPiatti(lista);
      } catch (err) {
        console.error("Errore caricamento piatti menu:", err);
      }
    };

    caricaPiattiMenu();
  }, [localeTag]);

  // Ricarica promozioni
  const ricaricaPromozioni = useCallback(async () => {
    if (!localeTag) return;
    
    setLoading(true);
    try {
      const q = query(
        collection(db, "promozioni"),
        where("localeTag", "==", localeTag)
      );
      const snapshot = await getDocs(q);
      
      const lista = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));
      
      setPromozioni(lista);
    } catch (err) {
      console.error("Errore nel caricamento promozioni:", err);
    }
    setLoading(false);
  }, [localeTag]);

  useEffect(() => {
    ricaricaPromozioni();
  }, [ricaricaPromozioni]);

  const compressBase64Image = (base64, maxWidth = 800, quality = 0.75) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = (maxWidth / width) * height;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL("image/jpeg", quality));
    };

    img.onerror = reject;
  });
};

const handleAIComplete = async ({ imageBase64 }) => {
  const imageUrl = `data:image/png;base64,${imageBase64}`;

  try {
    setAiPreviewUrl(imageUrl);
    setNuovaImmagine(null);
    setAiImageUploading(true);

    const compressed = await compressBase64Image(imageUrl, 800, 0.75);

    const finalUrl = await uploadAiImageViaFunction(
      compressed,
      localeTag || localStorage.getItem("localeTag")
    );

    setAiPreviewUrl(finalUrl);
  } catch (err) {
    console.error("Errore immagine AI promozione:", err);
    setSnackbar("❌ Errore durante il salvataggio immagine AI");
    setTimeout(() => setSnackbar(""), 3000);
  } finally {
    setAiImageUploading(false);
    setShowAIPopup(false);
  }
};

const selezionaPiattoPerPromo = (piatto) => {
  setNuovoTitolo(piatto.nome || "");
  setNuovaImmagine(null);

  if (piatto.immagineUrl) {
    setAiPreviewUrl(piatto.immagineUrl);
  } else {
    setAiPreviewUrl("");
  }

  setShowPiattoPicker(false);
};

  // Carica nuova promozione
  const caricaPromozione = async (e) => {
    e.preventDefault();
    
    if (!localeTag || localeTag.trim() === "") {
      setSnackbar("❌ Errore: Locale non identificato.");
      setTimeout(() => setSnackbar(""), 3000);
      return;
    }
    
    if (!nuovoTitolo.trim()) {
      setSnackbar("⚠️ Inserisci un titolo!");
      setTimeout(() => setSnackbar(""), 3000);
      return;
    }
    
  if (!nuovaImmagine && !aiPreviewUrl) {
  setSnackbar("⚠️ Seleziona o genera un'immagine!");
  setTimeout(() => setSnackbar(""), 3000);
  return;
}
    
    setUploading(true);
    
    try {
      let downloadURL = aiPreviewUrl;
let filePath = "";

if (nuovaImmagine) {
  const storage = getStorage();
  const filename = nuovaImmagine.name;
  const timestamp = Date.now();
  filePath = `promozioni/${localeTag}_${timestamp}_${filename}`;
  const fileRef = ref(storage, filePath);

  await uploadBytes(fileRef, nuovaImmagine);
  downloadURL = await getDownloadURL(fileRef);
}
      
      await addDoc(collection(db, "promozioni"), {
        localeTag: localeTag,
        titolo: nuovoTitolo,
        link: nuovoLink,
        imageUrl: downloadURL,
        storagePath: filePath,
        dimensione: dimensionePopup,
        timestamp: new Date(),
        attivo: true
      });
      
      setSnackbar("✅ Promozione caricata con successo!");
setNuovoTitolo("");
setNuovoLink("");
setNuovaImmagine(null);
setAiPreviewUrl("");
setDimensionePopup("medio");
setShowForm(false);
      
      await ricaricaPromozioni();
      setUploading(false);
      setTimeout(() => setSnackbar(""), 3000);
    } catch (err) {
      console.error("Errore nel caricamento promozione:", err);
      setSnackbar("❌ Errore nel caricamento");
      setTimeout(() => setSnackbar(""), 3000);
      setUploading(false);
    }
  };

  // Attiva/Disattiva promozione
  const toggleAttivo = async (id, attivoCorrente) => {
    try {
      await updateDoc(doc(db, "promozioni", id), { attivo: !attivoCorrente });
      setSnackbar(attivoCorrente ? "⏸️ Promozione disattivata" : "✅ Promozione attivata");
      setTimeout(() => setSnackbar(""), 3000);
      await ricaricaPromozioni();
    } catch (err) {
      console.error("Errore nell'aggiornamento:", err);
    }
  };

  // Elimina promozione
  const eliminaPromozione = async (id, storagePath) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa promozione?")) return;
    
    try {
      await deleteDoc(doc(db, "promozioni", id));
      
      if (storagePath) {
        try {
          const storage = getStorage();
          const fileRef = ref(storage, storagePath);
          await deleteObject(fileRef);
        } catch (err) {
          console.error("Errore nell'eliminazione file:", err);
        }
      }
      
      setSnackbar("🗑️ Promozione eliminata");
      setTimeout(() => setSnackbar(""), 3000);
      await ricaricaPromozioni();
    } catch (err) {
      console.error("Errore nell'eliminazione:", err);
      setSnackbar("❌ Errore nell'eliminazione");
      setTimeout(() => setSnackbar(""), 3000);
    }
  };

  // Apri modalità modifica
  const apriModifica = (promozione) => {
    setPromozioneInModifica(promozione);
    setNuovoTitolo(promozione.titolo);
    setNuovoLink(promozione.link);
    setDimensionePopup(promozione.dimensione);
    setAiPreviewUrl(promozione.imageUrl || "");
setImmagineOriginale(promozione.imageUrl || "");
setNuovaImmagine(null);
    setModalitaModifica(true);
    setShowForm(true);
  };

  // Chiudi modalità modifica
  const chiudiModifica = () => {
    setModalitaModifica(false);
    setPromozioneInModifica(null);
    setNuovoTitolo("");
    setNuovoLink("");
    setNuovaImmagine(null);
setAiPreviewUrl("");
setImmagineOriginale("");
setDimensionePopup("medio");
    setShowForm(false);
    setFormKey(prev => prev + 1);
  };

  // Salva modifiche promozione
  const salvaModifiche = async () => {
  if (!nuovoTitolo.trim()) {
    setSnackbar("⚠️ Inserisci un titolo!");
    setTimeout(() => setSnackbar(""), 3000);
    return;
  }

  setUploading(true);

  try {
    const updateData = {
      titolo: nuovoTitolo,
      link: nuovoLink,
      dimensione: dimensionePopup
    };

    if (aiPreviewUrl && aiPreviewUrl !== immagineOriginale) {
  updateData.imageUrl = aiPreviewUrl;
  updateData.storagePath = "";

  if (promozioneInModifica.storagePath) {
    try {
      const storage = getStorage();
      const oldFileRef = ref(storage, promozioneInModifica.storagePath);
      await deleteObject(oldFileRef);
    } catch (err) {
      console.error("Errore nell'eliminazione vecchia immagine:", err);
    }
  }
} else if (nuovaImmagine) {
      const storage = getStorage();
      const filename = nuovaImmagine.name;
      const timestamp = Date.now();
      const filePath = `promozioni/${localeTag}_${timestamp}_${filename}`;
      const fileRef = ref(storage, filePath);

      await uploadBytes(fileRef, nuovaImmagine);
      const downloadURL = await getDownloadURL(fileRef);

      updateData.imageUrl = downloadURL;
      updateData.storagePath = filePath;

      if (promozioneInModifica.storagePath) {
        try {
          const oldFileRef = ref(storage, promozioneInModifica.storagePath);
          await deleteObject(oldFileRef);
        } catch (err) {
          console.error("Errore nell'eliminazione vecchia immagine:", err);
        }
      }
    }

    await updateDoc(doc(db, "promozioni", promozioneInModifica.id), updateData);

    setSnackbar("✅ Promozione modificata con successo!");
    chiudiModifica();
    await ricaricaPromozioni();
    setTimeout(() => setSnackbar(""), 3000);
  } catch (err) {
    console.error("Errore nella modifica promozione:", err);
    setSnackbar("❌ Errore nella modifica");
    setTimeout(() => setSnackbar(""), 3000);
  } finally {
    setUploading(false);
  }
};

  return (
    <>
      <Navbar />
      <div className="gp-container">

  <div className="gp-header">

    <div className="gp-header-left">
      <h1 className="gp-title">
        🎉 Promozioni Popup
      </h1>

      <p className="gp-subtitle">
        Gestisci popup promozionali, offerte e comunicazione visiva del tuo locale.
      </p>
    </div>

    <button
      className="gp-primary-btn"
      onClick={() => {
        setModalitaModifica(false);
        setPromozioneInModifica(null);
        setNuovoTitolo("");
        setNuovoLink("");
        setNuovaImmagine(null);
        setAiPreviewUrl("");
        setImmagineOriginale("");
        setShowPiattoPicker(false);
        setDimensionePopup("medio");
        setShowForm(!showForm);
        setFormKey(prev => prev + 1);
      }}
    >
      {showForm
        ? "Chiudi"
        : "➕ Nuova Promozione"}
    </button>

  </div>

        {snackbar && (
  <div
    className={`gp-snackbar ${
      snackbar.includes("✅")
        ? "success"
        : "error"
    }`}
  >
    {snackbar}
  </div>
)}

        {/* Form caricamento nuova promozione */}
        {showForm && (
          <form
            key={formKey}
            className="gp-form-card"
            onSubmit={
              modalitaModifica
                ? (e) => {
                    e.preventDefault();
                    salvaModifiche();
                  }
                : caricaPromozione
            }
          >

            <h3 className="gp-form-title">
              {modalitaModifica
                ? "✏️ Modifica Promozione"
                : "📤 Nuova Promozione"}
            </h3>

            <div className="gp-field">
              <label className="gp-label">
                📝 Titolo Promozione
              </label>

              <input
                type="text"
                value={nuovoTitolo}
                onChange={(e) => setNuovoTitolo(e.target.value)}
                placeholder="Es. Pizza + Bibita a 9€"
                required
                className="gp-input"
              />
            </div>

            <button
              type="button"
              className="gp-secondary-btn"
              onClick={() => setShowPiattoPicker(true)}
            >
              🍽️ Scegli un piatto dal menu
            </button>

            <div className="gp-field">
              <label className="gp-label">
                🔗 Link (opzionale)
              </label>

              <input
                type="url"
                value={nuovoLink}
                onChange={(e) => setNuovoLink(e.target.value)}
                placeholder="https://..."
                className="gp-input"
              />
            </div>

            <div className="gp-field">
              <label className="gp-label">
                📏 Dimensione Popup
              </label>

              <div className="gp-size-grid">
  {[
    { value: "piccolo", label: "Piccolo", icon: "📱" },
    { value: "medio", label: "Medio", icon: "💻" },
    { value: "grande", label: "Grande", icon: "🖥️" },
    { value: "fullscreen", label: "Fullscreen", icon: "🌐" }
  ].map((size) => (
    <button
      key={size.value}
      type="button"
      className={`gp-size-option ${
        dimensionePopup === size.value ? "active" : ""
      }`}
      onClick={() => setDimensionePopup(size.value)}
    >
      <span>{size.icon}</span>
      <strong>{size.label}</strong>
    </button>
  ))}
</div>

              <div
  style={{
    marginTop: "18px",
    display: "flex",
    justifyContent: "center"
  }}
>

  <div
    style={{
      width:
        dimensionePopup === "piccolo"
          ? "180px"
          : dimensionePopup === "medio"
            ? "240px"
            : dimensionePopup === "grande"
              ? "320px"
              : "100%",

      maxWidth: "420px",

      height:
        dimensionePopup === "piccolo"
          ? "160px"
          : dimensionePopup === "medio"
            ? "220px"
            : dimensionePopup === "grande"
              ? "300px"
              : "380px",

      borderRadius: "26px",

      overflow: "hidden",

      position: "relative",

      transition: "all 0.28s ease",

background:
  aiPreviewUrl
    ? `url(${aiPreviewUrl}) center/cover`
    : nuovaImmagine
      ? `url(${URL.createObjectURL(nuovaImmagine)}) center/cover`
      : "linear-gradient(135deg,#1f1f24,#0f0f12)",

      border:
        "1px solid rgba(255,255,255,0.08)",

      boxShadow:
        "0 12px 40px rgba(0,0,0,0.45)"
    }}
  >

    <div
      style={{
        position: "absolute",
        inset: 0,

        background:
          "linear-gradient(to top, rgba(0,0,0,0.72), rgba(0,0,0,0.15))"
      }}
    />

    <div
      style={{
        position: "absolute",
        bottom: "18px",
        left: "18px",
        right: "18px",

        zIndex: 2
      }}
    >

      <div
        style={{
          fontSize:
            dimensionePopup === "piccolo"
              ? "1rem"
              : dimensionePopup === "medio"
                ? "1.2rem"
                : "1.5rem",

          fontWeight: "800",

          color: "#fff",

          marginBottom: "8px",

          lineHeight: 1.1
        }}
      >
        {nuovoTitolo || "La tua promozione"}
      </div>

      <div
        style={{
          color: "rgba(255,255,255,0.72)",
          fontSize: "0.82rem",
          marginBottom: "12px"
        }}
      >
        Anteprima popup cliente
      </div>

      <button
        type="button"
        style={{
          border: "none",

          background:
            "linear-gradient(135deg,#8b5cf6,#a855f7)",

          color: "white",

          padding: "10px 16px",

          borderRadius: "14px",

          fontWeight: "700",

          fontSize: "0.82rem",

          boxShadow:
            "0 8px 24px rgba(139,92,246,0.35)"
        }}
      >
        Scopri offerta
      </button>

    </div>

  </div>

</div>

            </div>

            <div className="gp-field">
              <label className="gp-label">
                🖼️ Immagine Promozione
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
  setNuovaImmagine(e.target.files[0]);
  setAiPreviewUrl("");
}}
                required={!modalitaModifica && !aiPreviewUrl}
                className="gp-input"
              />

<button
  type="button"
  className="gp-primary-btn"
  disabled={!aiEnabled || !aiCredits || aiImageUploading}
  style={{
    marginTop: "12px",
    width: "100%",
    opacity: !aiEnabled || !aiCredits || aiImageUploading ? 0.55 : 1
  }}
  onClick={() => {
    if (!nuovoTitolo.trim()) {
      setSnackbar("⚠️ Inserisci prima il titolo della promozione");
      setTimeout(() => setSnackbar(""), 3000);
      return;
    }

    if (!aiEnabled) {
      setSnackbar("⚠️ Generazione AI disabilitata");
      setTimeout(() => setSnackbar(""), 3000);
      return;
    }

    if (!aiCredits || aiCredits <= 0) {
      setSnackbar("⚠️ Crediti AI esauriti");
      setTimeout(() => setSnackbar(""), 3000);
      return;
    }

    setShowAIPopup(true);
  }}
>
  {aiImageUploading ? "⏳ Preparazione immagine..." : "✨ Genera con AI"}
</button>

<p
  style={{
    marginTop: "8px",
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.58)"
  }}
>
  Crediti AI Immagini: <strong>{aiCredits}</strong>
</p>

              {modalitaModifica && promozioneInModifica && (
                <div
                  style={{
                    marginTop: "10px",
                    color: "rgba(255,255,255,0.55)",
                    fontSize: "0.85rem"
                  }}
                >
                  Immagine attuale:
                  {" "}
                  {promozioneInModifica.titolo}
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={uploading}
              className="gp-primary-btn"
              style={{
                width: "100%",
                marginTop: "10px",
                opacity: uploading ? 0.6 : 1
              }}
            >
              {uploading
                ? "⏳ Elaborazione..."
                : modalitaModifica
                  ? "💾 Salva Modifiche"
                  : "💾 Salva Promozione"}
            </button>

          </form>
        )}

        {/* Lista promozioni esistenti */}
        {loading ? (
          <p style={{ textAlign: "center", color: "#fff", fontSize: "1.1rem" }}>
            🔄 Caricamento promozioni...
          </p>
        ) : promozioni.length === 0 ? (
          <div className="gp-empty">

  <div className="gp-empty-title">
    📭 Nessuna promozione caricata
  </div>

  <div className="gp-empty-subtitle">
    Crea la tua prima promozione popup per iniziare.
  </div>

</div>
        ) : (
          <div className="gp-grid">

            {promozioni.map((item) => (

              <div
                key={item.id}
                className={`gp-card ${!item.attivo ? "disabled" : ""}`}
              >

                <div className="gp-card-image-wrapper">

                  <img
                    src={item.imageUrl}
                    alt={item.titolo}
                    className="gp-card-image"
                  />

                  <div
                    className={`gp-status-badge ${
                      item.attivo
                        ? "active"
                        : "inactive"
                    }`}
                  >
                    {item.attivo
                      ? "ATTIVA"
                      : "IN PAUSA"}
                  </div>

                </div>

                <div className="gp-card-content">

                  <h3 className="gp-card-title">
                    {item.titolo}
                  </h3>

                  <div className="gp-meta">

                    <div>
                      📏 Dimensione:
                      {" "}
                      <strong>
                        {item.dimensione || "medio"}
                      </strong>
                    </div>

                    {item.link && (
                      <div>
                        🔗
                        {" "}
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="gp-link"
                        >
                          Apri link
                        </a>
                      </div>
                    )}

                    <div>
                      ⏱️
                      {" "}
                      {item.timestamp?.seconds
                        ? new Date(
                            item.timestamp.seconds * 1000
                          ).toLocaleDateString()
                        : "Data non disponibile"}
                    </div>

                  </div>

                  <div className="gp-actions">

                    <button
                      onClick={() => apriModifica(item)}
                      className="gp-action-btn gp-btn-edit"
                    >
                      ✏️ Modifica
                    </button>

                    <button
                      onClick={() =>
                        toggleAttivo(item.id, item.attivo)
                      }
                      className="gp-action-btn gp-btn-toggle"
                    >
                      {item.attivo
                        ? "⏸️ Stop"
                        : "▶️ Attiva"}
                    </button>

                    <button
                      onClick={() =>
                        eliminaPromozione(
                          item.id,
                          item.storagePath
                        )
                      }
                      className="gp-action-btn gp-btn-delete"
                    >
                      🗑️
                    </button>

                  </div>

                </div>

              </div>

            ))}

          </div>
        )}
            </div>
{showPiattoPicker && (
  <div className="gp-modal-overlay">
    <div className="gp-modal-card">
      <div className="gp-modal-header">
        <h3>Scegli un piatto</h3>

        <button
          type="button"
          className="gp-modal-close"
          onClick={() => setShowPiattoPicker(false)}
        >
          ×
        </button>
      </div>

      <div className="gp-dish-picker-list">
        {menuPiatti.length === 0 ? (
          <div className="gp-dish-picker-empty">
            Nessun piatto disponibile nel menu.
          </div>
        ) : (
          menuPiatti.map((piatto) => (
            <button
              key={piatto.id}
              type="button"
              className="gp-dish-picker-item"
              onClick={() => selezionaPiattoPerPromo(piatto)}
            >
              {piatto.immagineUrl ? (
                <img src={piatto.immagineUrl} alt={piatto.nome} />
              ) : (
                <div className="gp-dish-picker-placeholder">🍽️</div>
              )}

              <div>
                <strong>{piatto.nome}</strong>
                <span>
                  {piatto.categoria || "Senza categoria"}
                  {piatto.prezzo ? ` · ${Number(piatto.prezzo).toFixed(2)} €` : ""}
                </span>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  </div>
)}

      <AIImagePopup
        visible={showAIPopup}
        onClose={() => setShowAIPopup(false)}
        dishName={nuovoTitolo || "Promozione del locale"}
        aiCredits={aiCredits || 0}
        localeTag={localeTag}
        onComplete={handleAIComplete}
      />
    </>
  );
}

export default GestionePromozioni;
